import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=02be9b36&scoped=true&lang=pug&"
import script from "./Thanks.vue?vue&type=script&lang=js&"
export * from "./Thanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be9b36",
  null
  
)

export default component.exports